/**
 * Zod schema for contact form (feedback) validation
 */

import { z } from 'zod';
import type { Feedback } from './types';

export const FeedbackSchema = z.object({
  name: z.string(),
  email: z.string(),
  message: z.string(),
  // Cloudflare Turnstile token. Empty when captcha is not configured (dev).
  token: z.string(),
});

/**
 * Validate and normalize a contact form submission. Throws a ZodError if the
 * shape is invalid.
 */
export function validateFeedback(data: unknown): Feedback {
  return FeedbackSchema.parse(data);
}
